import { Trophy, TrendingUp } from 'lucide-react';
import type { TierProgressResponse } from '@lunit/shared-types';

interface TierProgressProps {
  tierProgress: TierProgressResponse;
}

export const TierProgress = ({ tierProgress }: TierProgressProps) => {
  const { currentTier, nextTier, spentToNext, progress } = tierProgress;

  const progressPercent = Math.min(100, Math.max(0, progress));

  // Fallback tier name if currentTier is null
  const tierName = currentTier?.name || 'Гость';

  return (
    <div className="rounded-brand border border-border bg-primary/10 p-4 shadow-lg">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/20">
          <Trophy className="h-7 w-7 text-primary" />
        </div>

        <div className="flex-1">
          <div className="flex items-center justify-between">
            <div className="text-xs uppercase tracking-wide text-text-muted">Ваш уровень</div>
            {nextTier && (
              <div className="flex items-center gap-1 text-xs text-text-muted">
                <TrendingUp className="h-3 w-3" />
                <span>
                  {Math.round(spentToNext)}₽ до {nextTier.name}
                </span>
              </div>
            )}
          </div>
          <div className="text-lg font-bold text-text-main">{tierName}</div>

          {nextTier && (
            <div className="mt-2">
              <div className="h-2 w-full overflow-hidden rounded-full bg-secondary">
                <div
                  className="h-full rounded-full bg-primary transition-all duration-300"
                  style={{ width: `${progressPercent}%` }}
                />
              </div>
            </div>
          )}

          {!nextTier && (
            <div className="mt-1 text-xs text-text-muted">Максимальный уровень достигнут!</div>
          )}
        </div>
      </div>
    </div>
  );
};
